import { FC } from 'react';
import { Board, Council } from 'types';

import { useTranslate } from 'hooks/useTranslate';
import { BoardEntityTypes } from 'types/Board';
import { useGetSummaryCards } from './hooks/useGetSummaryCards';
import { CardToShow } from './types/CardsToShow';

type BoardsSummarySectionProps = {
  boardType: BoardEntityTypes;
  boards: Council[] | Board[];
  cardsToShow: CardToShow;
};

const BoardsSummarySection: FC<BoardsSummarySectionProps> = ({
  boardType,
  boards,
  cardsToShow,
}) => {
  const { t } = useTranslate();

  const { summaryCards } = useGetSummaryCards({
    boardType,
    boards,
    cardsToShow,
  }).data;

  return (
    <div className="nk-block">
      <div className="row g-gs">
        {summaryCards.map((card) => (
          <div className="col-12 col-sm-6 col-xl-3" key={card.key}>
            <div className={`card card-full rounded-xl bg-${card.color}`}>
              <div className="card-inner">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <div className="fs-6 text-white text-opacity-75 mb-0">
                    {t(card.title)}
                  </div>
                  <a href="#" className="link link-white text-light d-none">
                    {t('See')}
                  </a>
                  <em className={`icon ni ${card.icon} text-white`} />
                </div>

                <h5 className="fs-1 text-white">
                  {card.value} <small className="fs-3">{t(card.title)}</small>
                </h5>

                <div className="fs-11px text-white text-opacity-75 mt-1">
                  <span className="text-white" />
                  {t(card.description)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardsSummarySection;
